import { A, useLocation } from "@solidjs/router";
import { createResource, Show, For, createMemo } from "solid-js";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Container,
} from "@suid/material";
import { createSignal } from "solid-js";
import { getCurrentUser } from "../auth.js";
import DashboardIcon from "@suid/icons-material/Dashboard";

const Layout = (props) => {
  const [user] = createResource(getCurrentUser);
  const location = useLocation();
  const [anchorEl, setAnchorEl] = createSignal(null);
  const open = () => Boolean(anchorEl());

  const handleClose = () => setAnchorEl(null);

  const navItems = createMemo(() => [
    { label: "Dashboard", href: "/dashboard", icon: <DashboardIcon sx={{ mr: 1 }} />, show: true },
  ]);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" elevation={0} sx={{ bgcolor: 'white', borderBottom: '1px solid', borderColor: 'grey.200' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Typography
              variant="h6"
              noWrap
              component="div"
              sx={{ mr: 4, display: 'flex', fontWeight: 800, color: 'primary.main', textDecoration: 'none' }}
            >
              PAXICO PMP
            </Typography>

            <Box sx={{ flexGrow: 1, display: 'flex', gap: 1 }}>
              <For each={navItems().filter(item => item.show)}>
                {(item) => (
                  <Button
                    component={A}
                    href={item.href}
                    sx={{ 
                      fontWeight: location.pathname === item.href ? 'bold' : 'normal',
                      color: location.pathname === item.href ? 'primary.main' : 'text.secondary',
                      textTransform: 'none',
                      px: 2
                    }}
                  >
                    {item.icon}
                    {item.label}
                  </Button>
                )}
              </For>
            </Box>

            <Box sx={{ flexGrow: 0 }}>
              <Show when={user()} fallback={<Button color="primary">Login</Button>}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', md: 'block' } }}>
                    {user().name}
                  </Typography>
                  <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ p: 0 }}>
                    <Show when={user().avatar} fallback={<Avatar alt={user().name}>{user().name?.[0]}</Avatar>}>
                      <img 
                        src={user().avatar} 
                        alt={user().name} 
                        referrerpolicy="no-referrer"
                        style={{ 
                          width: "40px", 
                          height: "40px", 
                          "border-radius": "50%", 
                          "object-fit": "cover"
                        }} 
                      />
                    </Show>
                  </IconButton>
                  <Menu
                    anchorEl={anchorEl()}
                    open={open()}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  >
                    <MenuItem onClick={() => { handleClose(); document.cookie = "token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"; window.location.href = "/login"; }}>Logout</MenuItem>
                  </Menu>
                </Box>
              </Show>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      
      <Box component="main" sx={{ flexGrow: 1 }}>
        {props.children}
      </Box>
    </Box>
  );
};

export default Layout;
